import React from "react";
import SearchForm from "../ui/form/poster/SearchForm";

export default function PosterSearchForm() {
    return (
        <SearchForm/>
    );
}
